module.exports = __webpack_public_path__ + "static/media/ic_dashboard.6ae63d56.svg";